import events from './events.json';
import createEvent from './create-event.json';
import eventSteps from './event-steps.json';

export default {
  events,
  createEvent,
  eventSteps,
};
